import {type ISavedCart} from '../schema';

export const canRemoveAssetFromSavedCart = (
	savedCart?: Pick<ISavedCart, 'canEdit'>,
) => savedCart?.canEdit === true;

export default canRemoveAssetFromSavedCart;
